module.exports = __webpack_public_path__ + "static/img/xi_11.01bafae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_11.jpg
// module id = 7IBj
// module chunks = 1